module.exports = __webpack_public_path__ + "static/PaymentPortal8bitcopy-021a17f17789ee9f5217879a2ce97d23.png";